namespace GeniuzPOS.ReportMasterData {
    export class Report_1410Columns {
        static columnsKey = 'ReportMasterData.Report_1410';
    }
}
